import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d137d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment__top" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "comment__user-name" }
const _hoisted_4 = { class: "comment__date" }
const _hoisted_5 = { class: "comment__bottom" }
const _hoisted_6 = { class: "comment__content-container" }
const _hoisted_7 = {
  key: 0,
  class: "comment__content"
}
const _hoisted_8 = {
  key: 1,
  class: "comment__stars"
}
const _hoisted_9 = { class: "comment__star" }
const _hoisted_10 = { class: "comment__comment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "comment" }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "comment__image",
        width: "40",
        height: "40",
        src: $props.userImage,
        onError: _cache[0] || (_cache[0] = 
          event =>
            (event.target.src = require('../../../assets/static/onerror-user.png'))
        ),
        alt: "",
        crossorigin: "anonymous"
      }, null, 40, _hoisted_2),
      _createElementVNode("span", _hoisted_3, _toDisplayString($props.userName), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString($props.date), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        ($props.label)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($props.label) + ": " + _toDisplayString($props.contentName), 1))
          : _createCommentVNode("", true),
        ($props.stars)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stars, (star) => {
                return (_openBlock(), _createElementBlock("span", _hoisted_9))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_10, _toDisplayString($props.comment ? $props.comment : ""), 1)
    ])
  ], 16))
}